import { type ExpandedFieldStateManager } from "./ExpandedFieldStateManager";
import { typeInfoFor } from "./TypeTagInfo";
import { type ValueInspectorRowInfo } from "./ValueInspectorRowInfo";
import { type ValuePath, concatPath } from "./ValuePath";
import { traverseObjectValue } from "./traverseObjectValue";
import { traverseValue } from "./traverseValue";

export function traverseSetValue(
	fieldExpander: ExpandedFieldStateManager,
	pathToS: ValuePath,
	s: Set<never>,
	shallow: boolean
) {
	const fields: ValueInspectorRowInfo[] = [];
	let i = 0;
	for (const value of s) {
		const typeInfo = typeInfoFor(value);
		const newPath = concatPath(pathToS, { type: "SetField", index: i++, value, typeInfo });
		fields.push(...traverseValue(fieldExpander, newPath, typeInfo, shallow));
	}

	return fields.concat(traverseObjectValue(fieldExpander, pathToS, s, shallow));
}
